import React, { useState, useEffect, useRef } from 'react';
import { supabase } from './supabase';

function Moments() {
  var [moments, setMoments] = useState([]);
  var [loading, setLoading] = useState(true);
  var [showForm, setShowForm] = useState(false);
  var [commentingOn, setCommentingOn] = useState(null);
  var [commentText, setCommentText] = useState('');
  var [replyTo, setReplyTo] = useState(null);
  var [content, setContent] = useState('');
  var [imageFile, setImageFile] = useState(null);
  var [imagePreview, setImagePreview] = useState(null);
  var [uploading, setUploading] = useState(false);
  var [deleteModal, setDeleteModal] = useState({ show: false, stage: 0, momentId: null });
  var [deletingComment, setDeletingComment] = useState(null);
  var fileInputRef = useRef(null);
  var [avatarMe, setAvatarMe] = useState(null);
  var [avatarHim, setAvatarHim] = useState(null);
  var [nicknameMe, setNicknameMe] = useState('\u77E5\u679D');
  var [nicknameHim, setNicknameHim] = useState('\u6797\u664F');
  var [avatarCharMe, setAvatarCharMe] = useState('\u679D');
  var [avatarCharHim, setAvatarCharHim] = useState('\u664F');

  useEffect(function() {
    fetchMoments();
    fetch((process.env.REACT_APP_API_URL || '') + '/api/profile-settings')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var g = function(k) { var i = data.find(function(d) { return d.key === k; }); return i ? i.value : null; };
        if (g('avatar_me')) setAvatarMe(g('avatar_me'));
        if (g('avatar_him')) setAvatarHim(g('avatar_him'));
        if (g('nickname_me')) { setNicknameMe(g('nickname_me')); setAvatarCharMe(g('nickname_me').charAt(0)); }
        if (g('nickname_him')) { setNicknameHim(g('nickname_him')); setAvatarCharHim(g('nickname_him').charAt(0)); }
      })
      .catch(function() {});
  }, []);

  var fetchMoments = async function() {
    // 惰性回复：先处理到期的待回复动态
    try {
      await fetch((process.env.REACT_APP_API_URL || '') + '/api/moments/process-due', { method: 'POST' });
    } catch(e) {}

    var result = await supabase
      .from('moments')
      .select('*')
      .order('created_at', { ascending: false });
    if (result.error) {
      setLoading(false);
      return;
    }
    var list = await Promise.all(
      (result.data || []).map(async function(moment) {
        var commentsResult = await supabase
          .from('moment_comments')
          .select('*')
          .eq('moment_id', moment.id)
          .order('created_at', { ascending: true });
        var likesResult = await supabase
          .from('moment_likes')
          .select('*')
          .eq('moment_id', moment.id);
        return Object.assign({}, moment, {
          comments: commentsResult.data || [],
          likes: likesResult.data || []
        });
      })
    );
    setMoments(list);
    setLoading(false);
  };

  var handleImageSelect = function(e) {
    var file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    var reader = new FileReader();
    reader.onload = function(ev) {
      setImagePreview(ev.target.result);
    };
    reader.readAsDataURL(file);
  };

  var removeImage = function() {
    setImageFile(null);
    setImagePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  var uploadImage = async function(file) {
    var ext = file.name.split('.').pop();
    var fileName = 'moments/' + Date.now() + '-' + Math.random().toString(36).substring(2, 8) + '.' + ext;
    var result = await supabase.storage.from('images').upload(fileName, file);
    if (result.error) {
      console.error('Upload error:', result.error);
      return null;
    }
    var urlResult = supabase.storage.from('images').getPublicUrl(fileName);
    return urlResult.data.publicUrl;
  };

  var postMoment = async function() {
    if (content.trim() === '' && !imageFile) return;
    setUploading(true);

    var imageUrl = null;
    if (imageFile) {
      imageUrl = await uploadImage(imageFile);
    }

    var delayMs = (10 + Math.floor(Math.random() * 11)) * 60 * 1000;
    var replyDueAt = new Date(Date.now() + delayMs).toISOString();

    await supabase.from('moments').insert([{
      content: content,
      author: 'zhizhi',
      image_url: imageUrl,
      reply_due_at: replyDueAt,
      reply_status: 'pending'
    }]).select();

    // 获取刚插入的动态ID
    var { data: latest } = await supabase.from('moments').select('id').eq('author', 'zhizhi').order('created_at', { ascending: false }).limit(1);
    var newMomentId = latest && latest[0] ? latest[0].id : null;

    setContent('');
    setImageFile(null);
    setImagePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
    setShowForm(false);
    setUploading(false);
    fetchMoments();

    // 惰性回复：不立刻触发，打开朋友圈页面时处理到期的
  };

  var toggleLike = async function(momentId) {
    var moment = moments.find(function(m) { return m.id === momentId; });
    var myLike = moment.likes.find(function(l) { return l.author === 'zhizhi'; });
    if (myLike) {
      await supabase.from('moment_likes').delete().eq('id', myLike.id);
    } else {
      await supabase.from('moment_likes').insert([{
        moment_id: momentId, author: 'zhizhi'
      }]);
    }
    fetchMoments();
  };

  var postComment = async function(momentId) {
    if (commentText.trim() === '') return;
    await supabase.from('moment_comments').insert([{
      moment_id: momentId,
      content: commentText,
      author: 'zhizhi',
      reply_to: replyTo ? replyTo.id : null
    }]);
    var savedComment = commentText;
    var savedReplyTo = replyTo;
    setCommentText('');
    setCommentingOn(null);
    setReplyTo(null);
    fetchMoments();

    // 如果评论的是林晏的动态，或者回复的是林晏的评论，触发他回复
    var moment = moments.find(function(m) { return m.id === momentId; });
    var shouldReply = false;
    if (moment && moment.author === 'aiden') {
      shouldReply = true;
    }
    if (savedReplyTo && savedReplyTo.author === 'aiden') {
      shouldReply = true;
    }
    if (shouldReply && moment) {
      try {
        await fetch((process.env.REACT_APP_API_URL || '') + '/api/auto-comment', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            moment_id: momentId,
            moment_content: moment.content,
            image_url: moment.image_url,
            reply_to_comment: savedComment
          })
        });
        fetchMoments();
      } catch (e) { console.log('reply-comment error:', e); }
    }
  };

  var formatTime = function(timestamp) {
    var date = new Date(timestamp);
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    var hour = date.getHours().toString().padStart(2, '0');
    var min = date.getMinutes().toString().padStart(2, '0');
    return month + '/' + day + ' ' + hour + ':' + min;
  };

  var deleteMessages = ['', '\u786E\u5B9A\u8981\u5220\u9664\u8FD9\u6761\u52A8\u6001\u5417\uFF1F', '\u771F\u7684\u8981\u5220\u5417\uFF1F\u5220\u4E86\u5C31\u6CA1\u4E86\u3002', '\u6700\u540E\u4E00\u6B21\u786E\u8BA4\u3002\u4E0D\u53EF\u6062\u590D\u3002'];

  var handleDelete = function(momentId) {
    setDeleteModal({ show: true, stage: 1, momentId: momentId });
  };

  var confirmDelete = function() {
    if (deleteModal.stage < 3) {
      setDeleteModal({ show: true, stage: deleteModal.stage + 1, momentId: deleteModal.momentId });
    } else {
      deleteMoment(deleteModal.momentId);
      setDeleteModal({ show: false, stage: 0, momentId: null });
    }
  };

  var cancelDelete = function() {
    setDeleteModal({ show: false, stage: 0, momentId: null });
  };

  var deleteMoment = async function(momentId) {
    var r1 = await supabase.from('moment_comments').delete().eq('moment_id', momentId);
    if (r1.error) { alert('删评论失败: ' + r1.error.message); return; }
    var r2 = await supabase.from('moment_likes').delete().eq('moment_id', momentId);
    if (r2.error) { alert('删点赞失败: ' + r2.error.message); return; }
    var r3 = await supabase.from('moments').delete().eq('id', momentId);
    if (r3.error) { alert('删动态失败: ' + r3.error.message); return; }
    fetchMoments();
  };

  var getAvatar = function(author) {
    if (author === 'aiden') {
      if (avatarHim) return React.createElement('img', { src: avatarHim, alt: '', style: { width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' } });
      return avatarCharHim;
    }
    if (avatarMe) return React.createElement('img', { src: avatarMe, alt: '', style: { width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' } });
    return avatarCharMe;
  };

  var getName = function(author) {
    if (author === 'aiden') return nicknameHim;
    return nicknameMe;
  };

  return (
    <div className="moments">
      <div className="moments-header">
        <div className="moments-title-new">{'\u670B\u53CB\u5708'}</div>
        <button className="moments-post-btn" onClick={function() { setShowForm(!showForm); }}>
          {showForm ? '\u53D6\u6D88' : '+ \u53D1\u52A8\u6001'}
        </button>
      </div>

      {showForm && (
        <div className="moments-form">
          <textarea
            className="moments-textarea"
            placeholder={'\u8BF4\u70B9\u4EC0\u4E48...'}
            value={content}
            onChange={function(e) { setContent(e.target.value); }}
            rows={4}
          />
          {imagePreview && (
            <div className="moments-image-preview">
              <img src={imagePreview} alt="preview" className="moments-preview-img" />
              <button className="moments-preview-remove" onClick={removeImage}>{'\u00D7'}</button>
            </div>
          )}
          <div className="moments-form-row">
            <div className="moments-form-author">
              <span className="moments-author-avatar zhi">{avatarMe ? <img src={avatarMe} alt="" style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:'50%'}} /> : avatarCharMe}</span>
              <span className="moments-author-label">{nicknameMe}</span>
            </div>
            <div className="moments-form-actions">
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleImageSelect}
              />
              <button className="moments-img-btn" onClick={function() { fileInputRef.current.click(); }}>
                +{'\u56FE\u7247'}
              </button>
              <button className="moments-submit-btn" onClick={postMoment} disabled={uploading}>
                {uploading ? '\u53D1\u5E03\u4E2D...' : '\u53D1\u5E03'}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="moments-list">
        {loading ? (
          <div className="moments-empty">{'\u52A0\u8F7D\u4E2D...'}</div>
        ) : moments.length === 0 ? (
          <div className="moments-empty">{'\u8FD8\u6CA1\u6709\u52A8\u6001\uFF0C\u53D1\u4E00\u6761\u5427'}</div>
        ) : (
          moments.map(function(moment) {
            var liked = moment.likes.some(function(l) { return l.author === 'zhizhi'; });
            return (
              <div key={moment.id} className="moment-card-new" style={{ overflow: 'hidden' }}>
                <div className="moment-top">
                  <div className={'moment-avatar ' + moment.author}>
                    {getAvatar(moment.author)}
                  </div>
                  <div className="moment-top-info">
                    <div className={'moment-name ' + moment.author}>
                      {getName(moment.author)}
                    </div>
                    <div className="moment-time-new">{formatTime(moment.created_at)}</div>
                  </div>
                  <button onClick={function() { handleDelete(moment.id); }} style={{
                    background: 'none', border: 'none', color: '#C4B8AE',
                    fontSize: 14, cursor: 'pointer', padding: '4px 8px',
                    marginLeft: 'auto', flexShrink: 0
                  }}>{'\u00B7\u00B7\u00B7'}</button>
                </div>

                <div className="moment-body">{moment.content}</div>

                {moment.image_url && (
                  <div className="moment-image-wrap">
                    <img src={moment.image_url} alt="" className="moment-image" onClick={function() { window.open(moment.image_url, '_blank'); }} />
                  </div>
                )}

                <div className="moment-bottom-actions">
                  <button
                    className={'moment-like-btn-new' + (liked ? ' liked' : '')}
                    onClick={function() { toggleLike(moment.id); }}
                  >
                    {liked ? '\u2665' : '\u2661'} {moment.likes.length > 0 ? moment.likes.length : ''}
                  </button>
                  <button
                    className="moment-comment-btn-new"
                    onClick={function() { setCommentingOn(commentingOn === moment.id ? null : moment.id); }}
                  >
                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: 4, verticalAlign: -2}}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                   {moment.comments.length > 0 ? moment.comments.length : ''}
                  </button>
                </div>
                {moment.comments.length > 0 && (
                  <div className="moment-comments-new">
                    {moment.comments.map(function(c) {
                      var repliedTo = c.reply_to ? moment.comments.find(function(x) { return x.id === c.reply_to; }) : null;
                      return (
                        <div key={c.id} className="moment-comment-new">
                          <div className="comment-top-row">
                            <span className={'moment-avatar ' + c.author} style={{ width: 20, height: 20, fontSize: 9, flexShrink: 0 }}>
                              {c.author === 'aiden' ? (avatarHim ? <img src={avatarHim} alt="" style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:'50%'}} /> : avatarCharHim) : (avatarMe ? <img src={avatarMe} alt="" style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:'50%'}} /> : avatarCharMe)}
                            </span>
                            <span className={'comment-author-new ' + c.author}>
                              {getName(c.author)}
                            </span>
                            {repliedTo && (
                              <span style={{ fontSize: 12, color: '#9E8E82' }}>
                                {' \u56DE\u590D '}
                                <span className={repliedTo.author}>{getName(repliedTo.author)}</span>
                              </span>
                            )}
                            <span className="comment-time">{formatTime(c.created_at)}</span>
                          </div>
                          <div className="comment-body">{c.content}</div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 2 }}>
                          <button onClick={function() { setReplyTo(c); setCommentingOn(moment.id); setCommentText(''); }} style={{
                            background: 'none', border: 'none', color: '#C4B8AE', fontSize: 11, cursor: 'pointer', padding: '2px 0'
                          }}>{'\u56DE\u590D'}</button>
                          {deletingComment === c.id ? (
                            <button onClick={function() {
                              supabase.from('moment_comments').delete().eq('id', c.id).then(function() { setDeletingComment(null); fetchMoments(); });
                            }} style={{
                              background: 'none', border: 'none', color: '#D4726A', fontSize: 11, cursor: 'pointer', padding: '2px 4px'
                            }}>{'\u786E\u8BA4\u5220\u9664?'}</button>
                          ) : (
                            <button onClick={function() { setDeletingComment(c.id); }} style={{
                              background: 'none', border: 'none', color: '#C4B8AE', fontSize: 11, cursor: 'pointer', padding: '2px 4px', opacity: 0.4
                            }}>{'\u5220\u9664'}</button>
                          )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {commentingOn === moment.id && (
                  <div>
                    {replyTo && (
                      <div style={{ fontSize: 12, color: '#9E8E82', padding: '6px 8px', display: 'flex', alignItems: 'center', gap: 6 }}>
                        {'\u56DE\u590D ' + getName(replyTo.author)}
                        <button onClick={function() { setReplyTo(null); }} style={{ background: 'none', border: 'none', color: '#C4B8AE', cursor: 'pointer', fontSize: 14 }}>{'\u00D7'}</button>
                      </div>
                    )}
                    <div className="moment-comment-form-new" style={{ boxSizing: 'border-box', maxWidth: '100%', overflow: 'hidden' }}>
                      <input
                        className="moment-comment-input-new"
                        style={{ minWidth: 0 }}
                        placeholder={replyTo ? '\u56DE\u590D' + getName(replyTo.author) + '...' : '\u5199\u8BC4\u8BBA...'}
                        value={commentText}
                        onChange={function(e) { setCommentText(e.target.value); }}
                        onKeyDown={function(e) {
                          if (e.key === 'Enter') postComment(moment.id);
                        }}
                      />
                      <button className="moment-comment-send-new" onClick={function() { postComment(moment.id); }}>
                        {'\u53D1\u9001'}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>

      {deleteModal.show && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.35)', display: 'flex',
          alignItems: 'center', justifyContent: 'center', zIndex: 999
        }} onClick={cancelDelete}>
          <div style={{
            background: '#FFFDF9', borderRadius: 16, padding: '28px 24px 20px',
            width: 280, boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
            textAlign: 'center'
          }} onClick={function(e) { e.stopPropagation(); }}>
            <div style={{ fontSize: 15, color: '#2C2C2C', lineHeight: 1.5, marginBottom: 20 }}>
              {deleteMessages[deleteModal.stage]}
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={cancelDelete} style={{
                flex: 1, padding: '10px 0', border: '1.5px solid #E8DFD6',
                borderRadius: 10, background: 'white', color: '#6B5E54',
                fontSize: 14, cursor: 'pointer'
              }}>{'\u53D6\u6D88'}</button>
              <button onClick={confirmDelete} style={{
                flex: 1, padding: '10px 0', border: 'none',
                borderRadius: 10, background: '#D4726A', color: 'white',
                fontSize: 14, cursor: 'pointer'
              }}>{deleteModal.stage < 3 ? '\u786E\u5B9A' : '\u5220\u9664'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Moments;
